// import "./accordian.scss";

function Accordion({ accordions, setAccordions, showRequestInfo=null}) {

	// const { primaryColor, secondaryColor, gradient } = props.theme.bayanTheme;
	const toggleItem = (accordions, index) => {
		setAccordions(accordions.map((accordion, i) => {
			if (i === index) {
				accordion.open = !accordion.open
			} else {
				// accordion.open = false;
			}

			return accordion;
		}));
	}

	const clickHandler = ($event) => {
		const el = $event.target.closest('a');
		if (el && $event.currentTarget.contains(el)) {
			showRequestInfo && el && el.id && el.id === "request_info_btn" ? showRequestInfo() : null;
		}
	
	}

	return (
		<div className="accordians">
			{ accordions.map((accordion, i) => (
					<div
					className={"accordian " + (accordion.open ? 'open' : '')}
						key={i}
					onClick={() => toggleItem(accordions, i)}
					>
						<div className="accordion-question">
							{accordion.heading}
						</div>
						<div className="accordion-answer w3-animate-zoom">
								<div onClick={clickHandler} className="rsvp-body-text" dangerouslySetInnerHTML={{ __html: accordion.content }}>
							</div>
						</div>
					</div>
        ))}
      </div>
		
	);
}

export default Accordion;
